<template>
  <footer class="jyre-footer" style="position: relative" data-test="jyre-footer">
    <div class="container text-center text-big">
      <div style="height: 10px"></div>
      <h2>
        <a
          role="link"
          class="a-unstyled"
          href="https://gyreteams.com"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-about-jyre-link"
        >
          <img
            src="../assets/brand/gyre-icon-lg-bg-green.png"
            style="width: 80px; margin-bottom: 5px"
            alt="Gyre logo"
          />
          <br />
          About Gyre
        </a>
      </h2>
      <div style="height: 15px"></div>
      <p>
        <a
          role="link"
          class="a-unstyled"
          href="https://gyreteams.com/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-website-terms-link"
          >Terms and Conditions</a
        >
        -
        <a
          role="link"
          class="a-unstyled"
          href="https://gyreteams.com/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-terms-of-service-link"
          >Terms of Service</a
        >
        -
        <a
          role="link"
          class="a-unstyled"
          href="https://gyreteams.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-privacy-policy-link"
          >Privacy Policy</a
        >
        -
        <a
          role="link"
          class="a-unstyled"
          href="https://gyreteams.com/cookie-policy"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-cookies-link"
          >Cookies</a
        >
        -
        <a
          role="link"
          class="a-unstyled"
          href="https://gyreteams.com/contact"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-contact-us-link"
          >Contact Us</a
        >
      </p>
      <div style="height: 15px"></div>

      <p data-test="footer-copyright">
        © {{ year }} - The Developing Leaders Partnership, trading as Gyre. Company Reg No: 10357459
        <br />
      </p>

      <div style="height: 15px"></div>
      <div class="icon-container">
        <a
          role="link"
          href="https://www.linkedin.com/company/gyreteams"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="linkedin"
          ><img
            src="../assets/footer-images/iconmonstr-linkedin-4.svg"
            style="width: 40px"
            alt="linkedin icon"
        /></a>
        <a
          role="link"
          href="https://www.youtube.com/@gyreteams"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="youtube"
          ><img
            src="../assets/footer-images/iconmonstr-youtube-9.svg"
            style="width: 40px"
            alt="youtube icon"
        /></a>
      </div>
      <div style="height: 45px"></div>
    </div>
    <!-- <div
      style="position: relative; overflow: hidden"
      :class="{ 'footer-the-cs-effect': done }"
      :style="{ 'z-index': started ? 9000 : 0 }"
      @click="start()"
    >
      <img
        src="../assets/footer-images/footer-1.png"
        class="footer-bg"
        style="position: static"
        alt="turquoise background"
      />
      <a
        href="https://gyreteams.com/about"
        v-if="started"
        target="_blank"
        class="footer-sun"
        :class="{ hiding: !done }"
        data-test="footer-sun"
      >
        <img src="../assets/brand/gyre-icon-sm-rounded.png" alt="logo" />
      </a>

      <img src="../assets/footer-images/footer-2.png" class="footer-bg" alt="blue background" />
      <img src="../assets/footer-images/footer-3.png" class="footer-bg" alt="small mountain" />
      <img src="../assets/footer-images/footer-4.png" class="footer-bg" alt="mountain chain" />

      <img
        alt="eagle"
        src="../assets/footer-images/eagle.png"
        class="footer-eagle"
        :class="animals.eagle"
        @click="find('eagle')"
        data-test="footer-eagle"
      />

      <img src="../assets/footer-images/footer-5.png" class="footer-bg" alt="mountain slope" />

      <img
        src="../assets/footer-images/wolf.png"
        class="footer-wolf"
        :class="animals.wolf"
        @click="find('wolf')"
        alt="wolf"
        data-test="footer-wolf"
      />
      <img
        alt="chipmunk"
        src="../assets/footer-images/chipmunk.png"
        class="footer-chipmunk"
        :class="animals.chipmunk"
        @click="find('chipmunk')"
        data-test="footer-chipmunk"
      />

      <img src="../assets/footer-images/footer-6.png" class="footer-bg" alt="forest" />
      <img src="../assets/footer-images/footer-7.png" class="footer-bg" alt="otter on a rock" />
      <img
        alt="chameleon"
        src="../assets/footer-images/chameleon.png"
        class="footer-chameleon"
        :class="animals.chameleon"
        @click="find('chameleon')"
        data-test="footer-chameleon"
      />
      <img
        alt="bear"
        src="../assets/footer-images/bear.png"
        class="footer-bear"
        :class="animals.bear"
        @click="find('bear')"
        data-test="footer-bear"
      />

      <div
        class="footer-octopus"
        :class="animals.octopus"
        @click="find('octopus')"
        data-test="footer-octopus"
      >
        <img src="../assets/footer-images/octopus.png" alt="octopus" />
      </div>

      <div
        class="footer-orangutan"
        :class="animals.orangutan"
        v-if="started"
        @click="find('orangutan')"
        data-test="footer-orangutan"
      >
        <img src="../assets/footer-images/orangutan.png" alt="orangutan" />
      </div>

      <div class="footer-otter" v-if="!started" data-test="footer-otter"></div>

      <div class="footer-speech-bubble" v-if="started && !foundAll">
        <img
          src="../assets/footer-images/speech-bubble-small.png"
          style="width: 100%"
          alt="speech bubble"
        />
        <img
          alt="question mark"
          class="footer-question-mark"
          v-if="next === 'orangutan'"
          src="../assets/footer-images/question-mark-2.png"
          data-test="footer-question-mark-1"
        />
        <img
          class="footer-question-mark"
          v-else
          src="../assets/footer-images/question-mark.png"
          alt="question mark"
          data-test="footer-question-mark-2"
        />

        <img
          class="find-me-next"
          v-if="next === 'bear'"
          src="../assets/footer-images/bear.png"
          alt="bear"
          data-test="footer-find-bear-next"
        />
        <img
          class="find-me-next"
          v-if="next === 'eagle'"
          src="../assets/footer-images/eagle.png"
          alt="eagle"
          data-test="footer-find-eagle-next"
        />
        <img
          class="find-me-next"
          v-if="next === 'chipmunk'"
          src="../assets/footer-images/chipmunk.png"
          alt="chipmunk"
          data-test="footer-find-chipmunk-next"
        />
        <img
          class="find-me-next"
          v-if="next === 'octopus'"
          src="../assets/footer-images/octopus.png"
          alt="octopus"
          data-test="footer-find-octopus-next"
        />
        <img
          class="find-me-next"
          v-if="next === 'chameleon'"
          src="../assets/footer-images/chameleon.png"
          alt="chameleon"
          data-test="footer-find-chameleon-next"
        />
        <img
          class="find-me-next"
          v-if="next === 'wolf'"
          src="../assets/footer-images/wolf.png"
          alt="wolf"
          data-test="footer-find-wolf-next"
        />
        <img
          class="find-me-next"
          v-if="next === 'orangutan'"
          src="../assets/footer-images/orangutan.png"
          alt="orangutan"
          data-test="footer-find-orangutan-next"
        />
      </div>

      <p
        v-if="!started"
        style="font-size: 50%; width: 100%; position: absolute; bottom: 0; cursor: pointer"
        class="text-center"
        data-test="footer-show-secret-button"
      >
        <br />
        Click here for a secret
      </p>
    </div> -->
  </footer>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";

import moment from "dayjs";
import uiConfig from "../ui-config";

const { release } = uiConfig;
const year = moment().year();

const animals = ref({
  octopus: "hiding",
  eagle: "hiding",
  chipmunk: "hiding",
  bear: "hiding",
  wolf: "hiding",
  chameleon: "hiding",
  orangutan: "offscreen",
});

const started = ref(false);
const done = ref(false);
const foundAll = ref(false);

const next = computed(() => {
  return Object.keys(animals.value).find((a) => animals.value[a] === "hiding");
});

function start(): void {
  started.value = true;
  window.setTimeout(() => {
    if (animals.value.orangutan === "offscreen") {
      animals.value.orangutan = "hiding";
    }
  }, 50);
}

function find(animal: string): void {
  started.value = true;
  animals.value[animal] = animals.value[animal] === "hiding" ? "found" : "hiding";

  if (!next.value) {
    foundAll.value = true;
    window.setTimeout(() => {
      done.value = true;
    }, 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.jyre-footer {
  padding-bottom: 0;
  // background-color: #eee;
  background: #ffffff;
  box-shadow: 0px -5px 10px #eee;
  user-select: none;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.footer-the-cs-effect {
  .footer-bg {
    filter: saturate(150%);
  }
}

.footer-bg {
  transition: 1s;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.footer-bear {
  cursor: pointer;
  position: absolute;
  top: 60%;
  right: 1%;
  width: 10%;
  transition: 1s;

  &.hiding {
    top: 56%;
    right: -8.5%;
  }
}

.footer-wolf {
  cursor: pointer;
  position: absolute;
  bottom: 27%;
  left: 31%;
  width: 2.8%;
  transition: 1s;
  &.hiding {
    left: 27.6%;
    bottom: 27.5%;
    width: 2.5%;
  }
}

.footer-eagle {
  cursor: pointer;
  position: absolute;
  bottom: 50.2%;
  width: 3%;
  right: 0.1%;
  transition: 1s;

  &.hiding {
    right: 0.1%;
    bottom: 45%;
  }
}

.footer-orangutan {
  cursor: pointer;
  position: fixed;
  top: -2.8vw;
  left: 30%;
  width: 8%;
  z-index: 9999999999999;
  transform: rotate(165deg);
  transition: 1s;

  img {
    width: 100%;
  }

  &.hiding {
    top: -4.1vw;
    transform: rotate(180deg);
  }

  &.offscreen {
    top: -11vw;
    transform: rotate(180deg);
  }
}

.footer-chipmunk {
  cursor: pointer;
  position: absolute;
  bottom: 1%;
  width: 3%;
  left: 20%;
  transition: 1s;

  &.hiding {
    width: 2.5%;
    left: 17%;
  }
}

.footer-octopus {
  cursor: pointer;
  position: absolute;
  bottom: calc(12% - 30px);
  width: 5%;
  height: 60%;
  right: 40%;
  overflow: hidden;
  transition: 1s;
  border-bottom: 30px solid transparent;

  img {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateY(60%);
    transition: 1s;
  }

  &.hiding {
    img {
      transform: translateY(80%);
    }
  }
}
.footer-chameleon {
  cursor: pointer;
  position: absolute;
  bottom: 37.5%;
  left: 7.5%;
  width: 4%;
  &.hiding {
    filter: contrast(40%) brightness(130%) sepia(100%) saturate(230%) hue-rotate(20deg);
  }
  transition: 1s;
}

.footer-otter {
  cursor: pointer;
  position: absolute;
  bottom: 5%;
  right: 20%;
  width: 10%;
  height: 15%;
}

.footer-sun {
  position: absolute;
  width: 23%;
  height: 60%;
  top: 0;
  left: 45%;
  border-radius: 5000px;
  background: white;
  transition: 1s;
  img {
    position: absolute;
    width: 86%;
    top: 10%;
    left: 7%;
  }

  &.hiding {
    top: 100%;
  }
}

.find-me-next {
  position: absolute;
  width: 54%;
  top: 8%;
  left: 8%;
}

.footer-speech-bubble {
  position: absolute;
  width: 10%;
  top: 65%;
  right: 28%;
}

.footer-question-mark {
  position: absolute;
  right: 10%;
  top: 14%;
  width: 46%;
}

.jyre-footer small {
  color: #aaa;
}
</style>
